import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonWithAsync from 'components/UI/ButtonWithAsync/ButtonWithAsync';
import Modal from 'components/UI/Antd/Modal/Modal';

import InfoCircleFilled from '@ant-design/icons/InfoCircleFilled';

import Button from 'components/UI/Antd/Button/Button';
import {
  ConfirmModalHeader,
  ConfirmModalBody,
  ConfirmIconWrapper,
  ConfirmModalContent,
  ConfirmDialogFooter
} from './ConfirmModal.style';

const AsyncButton = ButtonWithAsync(Button);

/*
 * ConfirmModal
 *
 * @param {boolean}  visible
 * @param {string}   title
 * @param {string}   [confirmButtonTitle='OK']
 * @param {Function} [onConfirm=()=>{}]
 * @param {Function} [onCancel=()=>{}]
 * @param {Node}     [children]    Node or Array of nodes
 */
export default function ConfirmModal({
  visible,
  title,
  confirmButtonTitle,
  cancelButtonTitle,
  onConfirm = () => {},
  onCancel = () => {},
  asyncConfirm,
  children,
  hideBackBtn = false
}) {
  const { t } = useTranslation();
  return (
    <Modal
      width={730}
      title={<ConfirmModalHeader>{title}</ConfirmModalHeader>}
      visible={visible}
      centered={true}
      onCancel={onCancel}
      wrapClassName='confirm-modal'
      zIndex={10001}
      footer={
        <ConfirmDialogFooter>
          <Button
            className='confirm_cancel_button'
            htmlType='button'
            onClick={onCancel}
            hidden= {hideBackBtn}
          >
            {cancelButtonTitle ? cancelButtonTitle : t('CANCEL')}
          </Button>
          {asyncConfirm ? (
            <AsyncButton
              asyncAction={onConfirm}
              htmlType='button'
              type='primary'
              label={confirmButtonTitle ? confirmButtonTitle : t('OK')}
            />
          ) : (
            <Button htmlType='submit' onClick={onConfirm} type='primary'>
              {confirmButtonTitle ? confirmButtonTitle : t('OK')}
            </Button>
          )}
        </ConfirmDialogFooter>
      }
    >
      <ConfirmModalBody>
        <ConfirmIconWrapper>
          <InfoCircleFilled style={{ color: '#194AB9' }} />
        </ConfirmIconWrapper>
        <ConfirmModalContent>{children}</ConfirmModalContent>
      </ConfirmModalBody>
    </Modal>
  );
}
